import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      const userCredential = await login(email, password);
      
      // Check if email is verified
      if (userCredential.user && !userCredential.user.emailVerified) {
        setError('Please verify your email before logging in.');
        return;
      }
      
      navigate('/scan');
    } catch (error) {
      setError('Failed to log in: ' + error.message);
    }

    setLoading(false);
  }

  return (
    <div className="auth-background">
      <Container 
        className="d-flex align-items-center justify-content-center" 
        // style={{ minHeight: "100vh" }}
      >
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Card className="shadow-lg border-0" style={{ backgroundColor: '#1a1d29', color: '#fff' }}>
            <Card.Body className="p-5">
              <h2 className="text-center mb-4 text-light">
                <span style={{ color: '#4f9eff' }}></span> Trade Central
              </h2>
              <h5 className="text-center mb-4">Log In</h5>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                </Form.Group>
                <Button 
                  disabled={loading} 
                  className="w-100 mt-3" 
                  type="submit"
                  style={{ 
                    backgroundColor: '#4f9eff', 
                    border: 'none',
                    padding: '12px'
                  }}
                >
                  {loading ? 'Logging In...' : 'Log In'}
                </Button>
              </Form>
              <div className="w-100 text-center mt-3">
                Need an account? <Link to="/signup" style={{ color: '#4f9eff' }}>Sign Up</Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
} 